// extracted by mini-css-extract-plugin
export default {"list":"InfoList_list__ZbnnT"};